import React from 'react';
import PropTypes from 'prop-types';

import MatchCard from '../../molecules/template-block-cards/match-card';
import styles from './template-block-cards.module.scss';

import { getAllEvents } from '../../../helpers/events';

const TemplateBlockCards = ({ pageContext }) => {
  const { relation } = pageContext?.page;
  const schedule = relation?.schedule;
  const showCasedEvents = relation?.showcased_events;
  // Get first tournament scheduled events
  const scheduleArray = schedule && Object.keys(schedule).map((key) => schedule[key]);
  const allEvents = getAllEvents(scheduleArray);
  const matchCards = showCasedEvents?.length ? showCasedEvents.slice(0, 3) : allEvents.slice(0, 3);

  return (
    <div className={styles.templateBlockCards}>
      <div className={styles.cards}>
        {matchCards.map((item) => (
          <div key={item.id} className={styles.card}>
            <MatchCard item={item} page={pageContext.page} />
          </div>
        ))}
      </div>
    </div>
  );
};

TemplateBlockCards.propTypes = {
  pageContext: PropTypes.shape({
    page: PropTypes.shape({
      relation: PropTypes.shape({
        featured_events: PropTypes.arrayOf(PropTypes.object),
        schedule: PropTypes.shape({}),
      }),
    }),
  }),
};

export default TemplateBlockCards;
